import md from '@/routes/middlewares';

import Member from '@/views/member/Member.vue';
import MemberPage from '@/views/member/MemberPage.vue';
import AssociatedProducts from '@/views/associatedProducts/AssociatedProducts.vue';
import ClientProduct from '@/views/associatedProducts/ClientProduct.vue';
import Sites from '@/views/sites/Sites.vue';
import ClientPage from '@/views/clients/ClientPage.vue';
import ClientInfoPage from '@/views/clients/Client.vue';
import ClientsMembersPage from '@/views/clients/ClientsMembersPage.vue';
import ClientsClientTeam from '@/views/clients/ClientsClientTeam.vue';
import ClientTeamMember from '@/views/member/ClientTeamMember';

import MassBalance from '@/views/MassBalance.vue';

import Contacts from '@/views/contacts/Contacts.vue';
import ContactPage from '@/views/ContactPage.vue';
import Contact from '@/views/contacts/Contact.vue';

import site from './site/site';

const client = {
    path: '/clients/:clientId',
    name: 'clientPage',
    component: ClientPage,
    redirect: { name: 'sites' },
    meta: {
        middlewares: [
            md.auth,
            md.accessControl,
            md.getClientInfo,
        ],
    },
    children: [
        site,
        {
            path: 'sites',
            name: 'sites',
            component: Sites,
        },
        {
            path: 'info',
            name: 'info',
            component: ClientInfoPage,
        },
        {
            path: 'massBalance',
            name: 'massBalance',
            component: MassBalance,
        },
        // CONTACTS
        {
            path: 'contacts',
            name: 'contacts',
            component: Contacts,
        },
        {
            path: 'contacts/:contactId',
            component: ContactPage,
            redirect: { name: 'contact' },
            meta: {
                middlewares: [
                    md.getContactInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'contact',
                    component: Contact,
                },
            ],
        },
        // MEMBERS/ASSIGNED USERS
        {
            path: 'assignedUsers',
            name: 'assignedUsers',
            component: ClientsMembersPage,
        },
        {
            path: 'assignedUsers/:memberId',
            component: MemberPage,
            redirect: { name: 'assignedUser' },
            meta: {
                middlewares: [
                    md.getMemberInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'assignedUser',
                    component: Member,
                },
            ],
        },
        // PRODUCTS
        {
            path: 'products',
            name: 'clientProducts',
            component: AssociatedProducts,
        },
        {
            path: 'products/:productId',
            name: 'clientProduct',
            component: ClientProduct,
            meta: {
                middlewares: [
                    md.getClientProductInfo,
                ],
            },
        },
        // CLIENT TEAM
        {
            path: 'manageClientTeam',
            name: 'manageClientTeam',
            component: ClientsClientTeam,
        },
        {
            path: 'manageClientTeam/:memberId',
            component: MemberPage,
            redirect: { name: 'clientTeamMember' },
            meta: {
                middlewares: [
                    md.getMemberInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'clientTeamMember',
                    component: ClientTeamMember,
                },
            ],
        },
    ],
};

export default client;
